import { useLazyImage } from '@/hooks/useLazyImage';
import { cn } from '@/lib/utils';

interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  priority?: boolean;
  width?: number;
  height?: number;
  threshold?: number;
  rootMargin?: string;
}

const OptimizedImage = ({ 
  src, 
  alt, 
  className, 
  priority = false,
  width,
  height,
  threshold,
  rootMargin 
}: OptimizedImageProps) => {
  const { 
    imgRef, 
    src: lazySrc, 
    loading, 
    onLoad, 
    className: lazyClassName 
  } = useLazyImage({ 
    src, 
    alt, 
    threshold, 
    rootMargin 
  });

  return (
    <img
      ref={imgRef}
      src={lazySrc}
      alt={alt}
      width={width}
      height={height}
      loading={priority ? 'eager' : loading}
      onLoad={onLoad}
      data-priority={priority ? 'high' : 'low'}
      className={cn(
        lazyClassName,
        'block max-w-full h-auto',
        className
      )}
      decoding="async"
    />
  );
};

export default OptimizedImage;